// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hc-ui .person_add_personal_form--field_birthdate .ui.date-picker-input,.hc-ui .person_add_personal_form--field_birthdate .ui.input{width:100%}.hc-ui .person_add_personal_form--field_set .ui.divider{visibility:hidden}\n", ""]);
// Exports
module.exports = exports;
